import { render, staticRenderFns } from "./HealthCodeManager.vue?vue&type=template&id=9b240dd8&scoped=true"
import script from "./HealthCodeManager.vue?vue&type=script&lang=js"
export * from "./HealthCodeManager.vue?vue&type=script&lang=js"
import style0 from "./HealthCodeManager.vue?vue&type=style&index=0&id=9b240dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b240dd8",
  null
  
)

export default component.exports